import { omit } from "lodash";
import { handleAction, handleActions } from "redux-actions";
import {
	ADD_NEW_APPLICATION,
	ADD_NEW_TICKET,
	ADD_NEW_USER,
	APPLICATION_FORM_TOOGLE_LOADING,
	AUTH,
	CLOSE_APPLICATION_FORM,
	CLOSE_NOTIFICATION,
	CLOSE_TICKET_FORM,
	CLOSE_USERS_FORM,
	DELETE_ALERT,
	DELETE_APPLICATION,
	DELETE_TICKET,
	DELETE_USER,
	EDIT_SELECTED_APPLICATION,
	EDIT_SELECTED_TICKET,
	EDIT_SELECTED_USER,
	LOGOUT,
	OPEN_APPLICATION_FORM,
	OPEN_TICKET_FORM,
	OPEN_USERS_FORM,
	SET_ALERT_LIST,
	SET_APPLICATION_LIST,
	SET_PROFILE,
	SET_TICKET_LIST,
	SET_USER_LIST,
	SHOW_NOTIFICATION,
	THEME,
	TICKET_FORM_TOOGLE_LOADING,
	UPDATE_APPLICATION,
	UPDATE_TICKET,
	UPDATE_USER,
	USERS_FORM_TOOGLE_LOADING,
} from "../../constants";

const CLOSED_FORM = { show: false, data: null, loading: false };

/** Lista normalizada por _id: fijar, añadir, actualizar y borrar. */
const listReducer = ({ set, add, update, remove }) =>
	handleActions(
		{
			[set]: (state, action) => action.payload,
			...(add ? { [add]: (state, action) => ({ ...state, [action.payload.value]: action.payload }) } : {}),
			...(update ? { [update]: (state, action) => ({ ...state, [action.payload.value]: action.payload }) } : {}),
			[remove]: (state, action) => omit(state, action.payload),
		},
		null
	);

/** Estado de un formulario modal: abierto, registro en edición y cargando. */
const formReducer = ({ open, close, edit, loading }) =>
	handleActions(
		{
			[open]: (state) => ({ show: !state.show, data: null, loading: false }),
			[close]: () => CLOSED_FORM,
			[edit]: (state, action) => ({ show: true, data: action.payload, loading: false }),
			[loading]: (state) => ({ ...state, loading: !state.loading }),
		},
		CLOSED_FORM
	);

export const authorization = handleActions(
	{
		[AUTH]: (state, action) => action.payload,
		[LOGOUT]: () => ({ auth: false }),
	},
	null
);

export const profile = handleActions({ [SET_PROFILE]: (state, action) => action.payload }, null);

export const notifications = handleActions(
	{
		[SHOW_NOTIFICATION]: (state, action) => action.payload,
		[CLOSE_NOTIFICATION]: (state) => ({ ...state, show: false }),
	},
	{ show: false, status: null, message: null }
);

export const currentTheme = handleAction(THEME, (state, action) => action.payload, true);

export const users = listReducer({ set: SET_USER_LIST, add: ADD_NEW_USER, update: UPDATE_USER, remove: DELETE_USER });
export const usersForm = formReducer({ open: OPEN_USERS_FORM, close: CLOSE_USERS_FORM, edit: EDIT_SELECTED_USER, loading: USERS_FORM_TOOGLE_LOADING });

export const alerts = listReducer({ set: SET_ALERT_LIST, remove: DELETE_ALERT });

export const applications = listReducer({ set: SET_APPLICATION_LIST, add: ADD_NEW_APPLICATION, update: UPDATE_APPLICATION, remove: DELETE_APPLICATION });
export const applicationsForm = formReducer({ open: OPEN_APPLICATION_FORM, close: CLOSE_APPLICATION_FORM, edit: EDIT_SELECTED_APPLICATION, loading: APPLICATION_FORM_TOOGLE_LOADING });

export const tickets = listReducer({ set: SET_TICKET_LIST, add: ADD_NEW_TICKET, update: UPDATE_TICKET, remove: DELETE_TICKET });
export const ticketsForm = formReducer({ open: OPEN_TICKET_FORM, close: CLOSE_TICKET_FORM, edit: EDIT_SELECTED_TICKET, loading: TICKET_FORM_TOOGLE_LOADING });
